// Generated by CoffeeScript 2.7.0
var SETTINGS, SettingsNavigator;

SETTINGS = [
  {
    title: '内部设置',
    list: Skylark.Helpers.translate('settings.inside_settings')
  },
  {
    title: '其他设置',
    list: Skylark.Helpers.translate('settings.other_settings')
  }
];

export var Navigator = Vue.extend({
  props: {
    initialSelectedSettingId: {
      type: String
    }
  },
  template: `<div class="sidebar-settings" data-has-navigator>
  <div class="sidebar-content">
    <template v-for="group in settings">
      <div class="list-group">
        <div class="list">
          <div class="list-title">{{ group.title }}</div>
          <a class="list-item node-wrapper justify-between"
             v-for="(value, key) in group.list"
             :href="goToPage(key)"
             :class="getActiveClass(key, value)"
             :key="key"
             @click="clickedListItem(key)"> {{ value }}</a>
        </div>
      </div>
    </template>
  </div>
</div>`,
  data: function() {
    return {
      settings: SETTINGS,
      selectedSettingId: this.initialSelectedSettingId
    };
  },
  methods: {
    getActiveClass: function(key) {
      return {
        'selected': key === this.selectedSettingId
      };
    },
    goToPage: function(key) {
      return Skylark.Helpers.UrlHelper.adminUrlFor(key.replace('__', '/'));
    },
    clickedListItem: function(key) {
      return this.selectedSettingId = key;
    }
  }
});

export default SettingsNavigator = {
  _generateSettingsSidebarView: function(id) {
    var navigator_el;
    navigator_el = DomMaster.find('[data-has-navigator]');
    return new Navigator({
      el: Skylark.Helpers.Utilities.getOrCreateCleaningElementByIdForVue('settings_sidebar'),
      propsData: {
        initialSelectedSettingId: id
      }
    });
  }
};
